<div class="dashboard-container">
	<app-navigator ></app-navigator>
	<div class="dashboard-content" style="display: inline-block;">
		<router-outlet></router-outlet>
	</div>
</div>